import {Component, Injector, OnInit} from '@angular/core';

@Component({
  selector: 'retroalimentacion-materias-barra',
  standalone: false,
  template: '<h1 *ngIf="alumno">{{alumno.apellidosNombres}}</h1>'
})

export class RetroalimentacionMateriasBarraComponent implements OnInit {

  alumno: any;

  constructor(private injector: Injector) {
  }

  ngOnInit() {
    this.alumno = this.injector.get('alumno');
  }
}
